const menu = '/menu'
const access = '/access'
const images = {
    logo : '/logo.png',
    menu : '/menu',
    favorite : menu+'/heart.png',
    wishList : menu+'/star.png',
    watched : menu+'/history.png',
    reviewed : menu+'/review.png',
    profile : menu+'/user.png',
    logout : menu+'/logout.png',
    no_profile : '/empty_profile.png',
    no_image : '/empty_image.png',
    upload : '/upload.png',
    PUBLIC : access+'/public.png',
    PRIVATE : access+'/private.png',
    avatar : '/avatar.png',
    no_result: '/noResults.png',
    topBanner: '/banner.png',
    arrowLine: '/arrow_line.png',
    home: '/home.gif'
}

export default images
